import React, { Component } from 'react';
import { observer } from 'mobx-react';
import FiltersStore from 'Stores/DocumentReload/FiltersStore';
import 'Styles/commonComponents/FiltersPanel/FiltersPanel.scss';
import AppStore from 'Stores/AppStore';
import CheckboxWithText from "Components/Common/CheckboxWithText";
import FilterBlockDateTimeRange from "Components/Common/FiltersPanel/FilterBlockDateTimeRange";

class FiltersPanel extends Component {

    constructor() {
        super();
    }

    render() {
        return (
            <div className='filter-panel'>
                <div id="regnum-alias-content">
                    <span>{AppStore.isMeeting ? 'Рег. №' : 'Рег. № РК/РКПД'}</span>
                    <input
                        id='filter-regnum-alias'
                        placeholder='Введите рег. номер'
                        className='regnum-input-placeholder-color'
                        onChange={event => FiltersStore.filtersRender.regNumAlias = event.target.value}
                        value={FiltersStore.filtersRender.regNumAlias}
                    />
                </div>

                <CheckboxWithText checked={FiltersStore.filtersRender.matchWholeWord}
                    onChange={(checked) => FiltersStore.filtersRender.matchWholeWord = checked}
                    text="Строгое соответствие"
                />

                <FilterBlockDateTimeRange
                    title="Дата регистрации в СЭД"
                    getValueFrom={() => FiltersStore.filtersRender.regDateStart}
                    setValueFrom={value => FiltersStore.filtersRender.regDateStart = value}
                    getValueTo={() => FiltersStore.filtersRender.regDateEnd}
                    setValueTo={value => FiltersStore.filtersRender.regDateEnd = value}
                    getRenderStore={() => FiltersStore.renderStore.dates}
                    setRenderStore={val => FiltersStore.renderStore.dates = val}
                    isTop={false}
                    getMinDate={() => AppStore.isMeeting
                        ? FiltersStore.filtersValues.meetingMinValueRegDate
                        : FiltersStore.filtersValues.docMinValueRegDate}
                    timeVisible={false}
                />
            </div>
        )
    }
}

export default observer(FiltersPanel);